export default __webpack_public_path__ + "static/media/06CCA3C0-00.ef467b44.png";